import React from 'react';
import { LucideIcon, TrendingUp, TrendingDown, Minus } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


interface MetricCardProps {
  label: string;
  value: string | number;
  subtext?: string;
  icon: LucideIcon;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  variant?: 'default' | 'warning' | 'danger' | 'positive';
  className?: string;
}

export default function MetricCard({
  label,
  value,
  subtext,
  icon: Icon,
  trend,
  trendValue,
  variant = 'default',
  className = '',
}: MetricCardProps) {
  const variantStyles = {
    default: { card: 'card-surface', icon: 'bg-primary/10 text-primary', border: '' },
    warning: { card: 'card-surface border-warning/30', icon: 'bg-warning/10 text-warning', border: 'border-l-2 border-l-warning' },
    danger: { card: 'card-surface border-danger/30', icon: 'bg-danger/10 text-danger', border: 'border-l-2 border-l-danger' },
    positive: { card: 'card-surface border-positive/20', icon: 'bg-positive/10 text-positive', border: '' },
  };

  const vs = variantStyles[variant];

  const TrendIcon = trend === 'up' ? TrendingUp : trend === 'down' ? TrendingDown : Minus;
  const trendColor = trend === 'up' ? 'text-positive' : trend === 'down' ? 'text-danger' : 'text-muted-foreground';

  return (
    <div className={`${vs.card} ${vs.border} p-5 flex flex-col gap-3 ${className}`}>
      <div className="flex items-start justify-between">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${vs.icon}`}>
          <Icon size={20} />
        </div>
        {trend && trendValue && (
          <div className={`flex items-center gap-1 text-xs font-semibold ${trendColor}`}>
            <TrendIcon size={12} />
            <span>{trendValue}</span>
          </div>
        )}
      </div>
      <div>
        <p className="text-hero-metric text-foreground">{value}</p>
        <p className="text-xs font-semibold uppercase tracking-widest mt-1" style={{ color: 'var(--muted-foreground)', letterSpacing: '0.06em' }}>
          {label}
        </p>
        {subtext && (
          <p className="text-xs mt-1" style={{ color: 'var(--muted-foreground)' }}>{subtext}</p>
        )}
      </div>
    </div>
  );
}